<template>
  <div v-if="loading && Bundles?.length !== 0">
    <Loader />
  </div>

  <section v-if="!loading && Bundles?.length !== 0">
    <div class=" pt-90 package-section">
      <div class="row y-gap-20 justify-between items-center">
            <div class="sectionTitle mb-30">
              <h2 class="sectionTitle__title">{{ $t('find_popular_packages') }}</h2>
              <p class="sectionTitle__text">
                {{ $t('featured_packages') }}
              </p>
            </div>
      </div>
      <!----- Switcher ----------->
      <!-- <div class="d-flex justify-content-center align-items-start mt-3 mb-4" id="switcher">
        <p class="me-2" :class="selectPlan === true ? 'active' : 'not-active'" for="switch">
          {{ $t('monthly') }}
        </p>
        <input type="checkbox" id="switch" v-model="selectPlan" /><label for="switch" class="pricing-switch"> Toggle </label>
        <p class="ms-1" :class="selectPlan === false ? 'active' : 'not-active'" for="switch">
          {{ $t('yearly') }}
        </p>
      </div> -->

      <!----- Packages Card ----->
      <div class="row">
        <div class="col-lg-4 col-md-6 mb-15 d-flex flex-column" v-for="slide in Bundles" :key="slide.slug">
          <PackageCard :showPrice="false" :item="slide" /> <!--:monthly="selectPlan"-->
        </div>
      </div>

      <!----<carousel v-bind="settings" :breakpoints="breakpoints" :autoplay="5000" :wrap-around="true" :dir="direction">
      <slide v-for="slide in Bundles" :key="slide.slug" class="mb-15 px-1">
        <PackageCard :showPrice="false" :item="slide" />
      </slide>

      <template #addons>
        <pagination />
      </template>
</carousel>-->
    </div>
  </section>
</template>

<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import AOS from "aos";
import "vue3-carousel/dist/carousel.css";
//import { Carousel, Slide, Pagination } from "vue3-carousel";
import { mapGetters } from "vuex";
import Loader from "../common/Loader.vue";
import PackageCard from "../common/PackageCard.vue";
//import { ShowBundles } from "@/Services/api/BundlesService";
export default {
  components: {
    Loader,
    //Carousel,
    //Slide,
    //Pagination,
    PackageCard
  },
  props: {
    Bundles: {
      type: Array
    }
  },
  data() {
    return {
      //selectPlan: false,
      latestCourses: null,
      loading: false,
      // Bundles: [],
      /* direction: localStorage.getItem("direction") || "ltr",
       settings: {
         itemsToShow: 1,
         snapAlign: "center",
       },
       breakpoints: {
         // 700px and up
         700: {
           itemsToShow: 1,
           snapAlign: "left",
         },
         900: {
           itemsToShow: 1,
           snapAlign: "left",
         },
         // 1024 and up
         1024: {
           itemsToShow: 2,
           snapAlign: "left",
         },
       }*/
    };
  },
  methods: {
    //async show bunbles
    /* async getBundles() {
       try {
         const response = await ShowBundles();
         this.Bundles = response.data.bundles;
       } catch (error) {
         console.log(error)
       }
     }*/
  },
  computed: {
    ...mapGetters(['currentLanguage']),
    userData() {
      return this.$store.getters.userData;
    },
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        // this.getBundles()
      },
      immediate: true, // Run the handler immediately when the component is mounted
    }
  },
  mounted() {
    /*window.addEventListener("direction-localstorage-changed", (event) => {
      this.direction = event.detail.storage;
    });*/
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
<style lang="scss" scoped>
.active {
  color: #0e5879eb;
}

.not-active {
  color: #ddd;
}

/***Switcher Container ***/
#switcher {
  padding-top: 10px;
}

input[type=checkbox]#switch {
  height: 0;
  width: 0;
  visibility: hidden;
}

label.pricing-switch {
  cursor: pointer;
  -ms-flex-item-align: start;
  align-self: flex-start;
  margin-top: 8px;
  text-indent: -9999px;
  width: 40px;
  height: 20px;
  background: #0e5879eb;
  display: block;
  margin-right: 12px;
  margin-left: 12px;
  border-radius: 100px;
  position: relative;

  &:lang(en) {
    transform: rotate(0deg);
  }

  &:lang(ar) {
    transform: rotate(180deg);
  }

  &::after {
    content: '';
    position: absolute;
    top: 4px;
    right: 5px;
    width: 12px;
    height: 12px;
    background: #fff;
    border-radius: 90px;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
  }
}

#switcher {
  p {
    &:lang(en) {
      font-weight: 400;
    }

    &:lang(ar) {
      font-weight: 600;
    }

    font-size: 24px;
    line-height: 1.4;
  }
}

input:checked+label.pricing-switch:after {
  right: calc(100% - 28px);
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
}

label.pricing-switch:active::after {
  width: 15px;
}

/*************** */

p,
div {
  &:lang(en) {
    text-align: left !important;
  }

  &:lang(ar) {
    text-align: right !important;
  }
}
@media screen and (max-width: 560px){
  .pt-90{
    padding-top: 40px !important; 
  }
}
</style>